import styled from '@emotion/styled';

export const ImageLayer = styled.div<{ rounded?: boolean; shadow?: boolean }>`
  background-repeat: no-repeat;
  background-size: 100%;
  position: absolute;

  ${({ rounded }) =>
    rounded &&
    `
    border-radius: 8px;
  `};
`;
